import config from 'constants/config'
import getPaymentMethods from 'lib/payment/getPaymentMethods'
import isSafari from 'lib/web/isSafari'
import isChrome from 'lib/web/isChrome'
import {
  APPLE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

// Detect any iOS/iPadOS device (all browsers on iOS use WebKit and support Apple Pay)
const isIOSDevice = typeof navigator !== 'undefined' && (
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
)

/** Original narrow check — macOS Safari only (excludes Chrome/Firefox on iOS). */
export const isApplePayEnabled = (currency: string): boolean => !!(config.APPLE_PAY_ENABLED && getPaymentMethods(currency).includes(APPLE_PAY_PAYMENT_TYPE) && !isChrome && isSafari)

/**
 * Broadened check — all iOS/iPadOS browsers + macOS Safari.
 * All iOS browsers use WebKit under the hood and support Apple Pay natively.
 * Used when the express checkout experiment is active so the broadened
 * availability can be rolled back by turning off the experiment.
 */
export const isApplePayEnabledBroadened = (currency: string): boolean => !!(
  config.APPLE_PAY_ENABLED &&
  getPaymentMethods(currency).includes(APPLE_PAY_PAYMENT_TYPE) &&
  (isIOSDevice || isSafari)
)
